<template>
  <v-dialog v-model="value" max-width="600">
    <template #activator="{ on }">
      <slot name="activator" :on="on"> </slot>
    </template>
    <template #default>
      <v-card>
        <v-toolbar color="primary" dark>{{ title }}</v-toolbar>
        <v-card-text>
          <div class="text-body-1 pt-6">{{ message }}</div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="handleClose">Close</v-btn>
          <v-btn text v-on="listeners" color="primary" :loading="loading"> Confirm </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
export default {
  name: "DialogConfirm",
  components: {},
  mixins: [],
  props: {
    title: {
      type: String,
      required: false,
      default: "Confirm",
    },
    message: {
      type: String,
      required: false,
      default: "Confirm",
    },
  },
  data: () => {
    return {
      value: false,
      loading: false,
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        click: this.handleConfirm,
      };
    },
  },
  methods: {
    async handleConfirm(event) {
      try {
        this.loading = true;
        await this.$listeners.confirm(event);
        this.value = false;
      } finally {
        this.loading = false;
      }
    },
    handleClose() {
      this.value = false;
    },
  },
};
</script>
